// Diccionario page → message key. Resuelve el título de cada pantalla
// vía msg() (i18n del theme con cadena de herencia keycloak.v2 → base).
// Las keys deben estar también en __KC_MSG_KEYS de template.ftl.

import { msg } from "./i18n";

const PAGE_TITLE_KEYS: Record<string, string> = {
  error: "errorTitle",
  "login-config-totp": "loginConfigTotpTitle",
  "login-reset-password": "emailForgotTitle",
  "login-otp": "loginOtpTitle",
  "email-otp": "emailOtpTitle",
  "login-update-password": "loginUpdatePasswordTitle",
  login: "loginTitle",
  register: "registerTitle",
  "login-page-expired": "loginPageExpiredTitle",
  "login-oauth-grant": "loginOauthGrantTitle",
  "login-oauth2-device-verify-user-code": "oauth2DeviceVerificationTitle",
  "delete-credential": "deleteCredentialPageTitle",
};

export function pageTitle(page: string): string {
  const key = PAGE_TITLE_KEYS[page];
  if (key) return msg(key);
  return "FacturaDirecta";
}
